<template>
  <m-card
    class="atlas-goal-card"
    padding-xs
  >
    <list-item
      :entity="goal"
      :props="props"
      tiny
      @select="openInModal"
    />
    <m-dialog
      v-model:value="showModal"
      :max-width="$modalSizes.xl"
      :closable="false"
      hide-footer
      no-padding
      hide-header
      top="7rem"
    >
      <full-screen-spinner
        v-if="loading"
        :height="300"
      />
      <goal-page
        v-else
        :key="goalId"
        :goal-id="goalId"
        :goal-cycles="goalCycles"
        :route-after-delete="{ name: GOALS_ATLAS }"
        scroll-container="m-dialog"
        open-in-modal
        @close="showModal = false"
        @deleted="$emit('deselect')"
        @open="open"
      />
    </m-dialog>
  </m-card>
</template>

<script>
import FullScreenSpinner from 'shared/components/FullScreenSpinner.vue';
import GoalPage from '@/components/goal/GoalPage.vue';
import ListItem from '@/components/list/ListItem.vue';
import useGoals from '@/composables/goal/goals';
import useLoggedInUser from '@/composables/logged-in-user/logged-in-user';
import { GOALS_ATLAS, GOAL_DETAILS } from '@/route-names';
import { computed } from 'vue';
import { createProp } from '@/lib/props';
import { directProperties } from '@/lib/goal/properties';
import { goal as goalConfig } from 'shared/api/query/configs.json';

export default {
  name: 'AtlasGoalCard',
  props: {
    goalId: {
      type: Number,
      required: true,
    },
    showActions: {
      type: Boolean,
      default: true,
    },
    goalCycles: {
      type: Array,
      required: true,
    },
    context: {
      type: String,
      default: '',
    },
  },
  setup(props) {
    const goalSelector = useGoals();
    const { userLang } = useLoggedInUser();
    const goal = computed(() => goalSelector.selectSingle(props.goalId));
    return { goal, userLang };
  },
  emits: ['deselect'],
  components: { ListItem, GoalPage, FullScreenSpinner },
  data() {
    return {
      GOALS_ATLAS,
      showModal: false,
      loading: false,
      props: directProperties((key) => this.$t(key), this.goalCycles).filter((p) => p.showInTinyView).map((p) => createProp(p, true, true, true, this.userLang, goalConfig.model)),
    };
  },
  methods: {
    openInModal() {
      this.showModal = true;
    },
    open(goal) {
      this.showModal = false;
      this.$router.push({
        name: GOAL_DETAILS,
        params: { goalId: goal.uid },
      });
    },
  },
};
</script>

<style
    scoped
    lang="scss"
    type="text/scss"
>
</style>
